import { defineStore } from 'pinia'
import { userinfo, requestGift } from '@/api'
import { requestCash, requestGiftList } from '@/api/host'
import { UserInfo } from '@/types/response'

export const useUserStore = defineStore('user', {
  state: (): UserInfo & { openModal: boolean } =>
    Object.assign(
      {
        id: 0,
        logo: '',
        certStatus: 'Init', // 认证状态 Init 、Succeed
        certType: 'Uncertified', // Personal
        createAt: '',
        credit: 0,
        from: '',
        mobile: '',
        email: '',
        name: '',
        openModal: false,
        isStudent: false, // 是否是学生
        isChild: false, // 是否是子账号
        permission: {
          createGPUInstance: false,
          createImageAPP: false,
          openYunBucket: false,
          gpu: false,
          app: false,
          image: false,
          usingLLM: false,
        }, // 子账号权限
        firstVisit: false, // 判断是否是新用户
        certified: false, // 是否认证
        userVersion: -1,
        nickname: '',
        childName: '',
        cash: 0, // 用户余额
        obtained: false, // 取首张6元券: 没充值 首张就是待领取 充值成功obtained： true
        recharged: false,
        remain: 0, // 体验金剩余额度
        renewStatus: false,
        expireAt: '',
        gift: [],
      },
      JSON.parse(localStorage.getItem('userInfo') as string), // store持久化，避免刷新页面数据丢失
    ),
  actions: {
    async getUserBasicInfo(): Promise<UserInfo> {
      const user = await userinfo()
      const money = await requestCash()
      // const resGift = await requestGift()
      // const giftList = await (await requestGiftList()).items
      localStorage.setItem('userCash', JSON.stringify(money.cash))
      const remain = 0
      // giftList.forEach((item) => {
      //   if (
      //     (item.remain as number) > 0 &&
      //     new Date(item.expireAt as string) >= new Date() &&
      //     item.status === 1
      //   ) {
      //     remain += item.remain as number
      //   }
      // })
      // 未领取
      // const renewStatus = !!giftList.filter((item) => {
      //   return item.status === 0
      // }).length
      const res = Object.assign({}, user, money, { remain })
      this.$patch(res)
      localStorage.setItem('userInfo', JSON.stringify(res))
      return res
    },
  },
})

export const useSpinStore = defineStore('loading', {
  state: (): { loading: boolean } => ({
    loading: false,
  }),
})

export const useHeaderNotify = defineStore('headerNotify', {
  state: () => ({
    status: false,
  }),
  actions: {
    close() {
      this.$patch({ status: false })
    },
  },
})
// 记录回跳地址
export const useCallbackUrl = defineStore('callbackUrl', {
  state: () => ({
    callbackUrl: '',
  }),
  actions: {
    setUrl(callbackUrl: string) {
      this.$patch({ callbackUrl })
    },
  },
  persist: true, // 强缓存
})

// 记录支付回头
export const usePayUrl = defineStore('payUrl', {
  state: () => ({
    url: '',
  }),
  actions: {
    setUrl(url: string) {
      this.$patch({ url })
    },
  },
})
